import { LinkingOptions } from '@react-navigation/native';
import { RootStackParamList } from '../types';

export const linkingConfig: LinkingOptions<RootStackParamList> = {
  prefixes: [
    'http://localhost:8081',
    'https://clubswap.app',
    'https://www.clubswap.nl',
    'https://clubswap.nl',
    'clubswap://',
  ],
  config: {
    screens: {
      // Auth screens
      Login: 'login',
      Register: 'register',
      ForgotPassword: 'forgot-password',
      ResetPassword: 'reset-password',
      ChangePassword: 'change-password',

      // Main screens
      Home: '',
      ItemDetails: 'item/:itemId',
      ItemForm: 'item/form/:itemId?',
      MarkAsSold: 'item/:itemId/sold',
      Browse: 'browse',
      Profile: 'profile',
      EditProfile: 'edit-profile',
      Clubs: 'clubs',
      ClubDetail: 'clubs/:clubId',
      ClubLeaderboard: 'clubs/leaderboard',

      // Admin screens
      AdminDashboard: 'admin',
      AdminSettings: 'admin/settings',
      ManageUsers: 'admin/users',
      ManageClubs: 'admin/clubs',
      AdminModeration: 'admin/moderation',
      AdminListings: 'admin/listings',
      AdminOptionLists: 'admin/option-lists',
      AdminCustomValues: 'admin/custom-values',
      AdminPayouts: 'admin/payouts',

      // Onboarding
      onboarding: 'onboarding',

      // Messaging
      ConversationsList: 'conversations',
      Chat: 'chat/:conversationId',
    },
  },
};
